import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useContext,
} from 'react'
import { SliderWrapperNew } from './SliderStyles'
import { Slider_props } from './interface'
import DiamondSVG from './Diamond'
import { MyContext } from '../../../../context/createContext'

export default function Slider({
  title,
  handleSliderValue,
  focusedHandler,
  socketValue,
  focused,
  startAuto,
  active,
}: Slider_props) {
  const { context } = useContext(MyContext)
  const { sliderValue, rollUnder, settings } = context

  const [value, setValue] = useState<number>(sliderValue)
  const [rollUnderValue, setRollUnder] = useState<any>(settings.over_or_under)
  const [min] = useState('5.00')
  const [max] = useState('96.00')
  const [anim, setAnim] = useState<boolean>(false)

  const track = useRef<any>(null)

  useEffect(() => {
    handleChange(socketValue)
  }, [socketValue])

  useEffect(() => {
    handleChange(sliderValue)
  }, [active, sliderValue])

  useEffect(() => {
    sliderValue !== value && handleChange(sliderValue)
  }, [value, sliderValue])

  const handleChange = useCallback(
    (e: any) => {
      let val
      if (!e) {
        val = '50'
      } else {
        val = e.target ? e.target.value : e
      }
      setValue(val)
      handleSliderValue(val)
      trackHandler(val)
      // focusedHandler(true)
    },
    [value],
  )

  const trackHandler = (value: any) => {
    const track = document.getElementById(`track-inner-${title}`)
    const trackOut = document.getElementById(`track-outter-${title}`)
    const thumb = document.getElementById(`thumb-${title}`)
    const number = document.getElementById(`track-number-${title}`)
    if (track && trackOut && thumb && number) {
      track.style.width = `${Number(value)}%`
      trackOut.style.width = 100 - Number(track.style.width.slice(0, -1)) + '%'
      thumb.style.left = value + '%'
      number.style.left = value + '%'
    }
  }

  useEffect(() => {
    setAnim(true)
    const animtimeout = setTimeout(() => setAnim(false), 300)
    return () => {
      clearTimeout(animtimeout)
    }
  }, [rollUnder])

  useEffect(() => {
    if (rollUnder == '1') {
      setRollUnder('0')
    } else if (rollUnder == '0') setRollUnder('1')
    else setRollUnder(rollUnder)
  }, [rollUnder])

  return (
    <SliderWrapperNew
      rollUnder={rollUnderValue == '0'}
      anim={anim}
      focus={focused}
      startAuto={startAuto}
    >
      <input
        type={'range'}
        min={min}
        max={max}
        step={1}
        value={value}
        onChange={e => handleChange(e)}
        onMouseDown={() => focusedHandler(true)}
        onMouseUp={() => focusedHandler(false)}
        onTouchEnd={() => focusedHandler(false)}
        onMouseLeave={() => focusedHandler(false)}
      />
      <div className='track' ref={track}>
        <div className='track-inner' id={`track-inner-${title}`}></div>
        <div className='thumb' id={`thumb-${title}`}>
          <DiamondSVG rollUnder={rollUnderValue == '0'} focus={focused} />
        </div>
        <div className='value' id={`track-number-${title}`}>
          <span>{(+value).toFixed(2)}</span>
        </div>
        <div className='track-outter' id={`track-outter-${title}`}></div>
      </div>
    </SliderWrapperNew>
  )
}
